import { Injectable } from "@angular/core";
import { ApiService } from "../../../shared/services/api.service";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class TimelineService extends ApiService {
  constructor() {
    super();
  }

  public requestGhcTimelineYears(): Observable<any> {
    const queryStringParams = this.makeQueryStringParams();
    const url = `${this.api}/ghc-metadata/years${queryStringParams}`;
    const response: any = this.httpClient.get(url);
    return response;
  }
}
